export default __webpack_public_path__ + "images/picture_you-choose-what-you-sell_productcategories.webp?11628de8e534c3ee4915173ccd43ebee";